export default "__VITE_ASSET__gpjuEKGA__"